import { createAction, props } from "@ngrx/store";

export const GET_ALL_CUSTOMERS = '[Customers] Get All Get All Customers';

export const ERROR = '[Customers] Error';

export const getAllCustomers = createAction(GET_ALL_CUSTOMERS);

export const error = createAction(ERROR, props<{error: string}>());